import Swiper from '../../../../../vendor/swiper/swiper-bundle.mjs';

export default class SwiperPageHeader {
    constructor($el) {
        this.$el = $el;
        this.slide = this.slide.bind(this);
        this.slide();
    }

    slide() {
        var swiper = new Swiper(this.$el, {
            slidesPerView: 1,
            drag: true,
            pagination: {
                el: this.$el.querySelector('[data-swiper-pagination]'),
            },
        });
    }
}